/**
 * Z pole vyfiltruje určité hodnoty. Původní pole zůstane nezměněno.
 *
 * @param array Pole, ze kterého funkci vyfiltruje hodnoty.
 * @param exludedElements Pole hodnot, které se mají odstranit.
 */
export const excludeFromArray = <T,>(array: ReadonlyArray<T>, exludedElements: ReadonlyArray<T>): T[] => array.filter(
    element => !exludedElements.includes(element),
);
